exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".discount-active {\n  background-color: #ffda2e;\n  background-image: -webkit-gradient(linear, left top, right top, from(#ff8d47), to(#ffda2e));\n  background-image: linear-gradient(to right, #ff8d47, #ffda2e);\n  color: #fff;\n}\n.discount-active a {\n  color: #fff;\n  text-decoration: underline;\n}\n.ant-table-row-hover {\n  color: #f7931e;\n}\n.ant-table-row-hover a {\n  color: #f7931e;\n}\n.ant-table-scroll tr.discount-active {\n  border-left: 5px solid #fa541c;\n}\n", ""]);

// exports
